import { render, staticRenderFns } from "./KPIListView.vue?vue&type=template&id=6d5a272a&"
import script from "./KPIListView.vue?vue&type=script&lang=ts&"
export * from "./KPIListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports